/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import { Add as AddIcon } from '@mui/icons-material';
import { Button } from '@mui/material';
import Paper from '@mui/material/Paper';
/* eslint-disable */
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import * as React from 'react';
import { useCallback } from 'react';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import uuid from 'react-uuid';
import { Reorder, getItemListStyle } from '../../../utils';
import { useTableDataContext } from '../../context/EditingTableDataContext';
import {
  CellHeaderStyled,
  TableBodyStyled,
  TableHeadStyled,
} from '../../styles';
import { columns } from '../../utils';
import { FirstLayerRow } from './components/FirstLayerRow';

export const EditingTable = () => {
  const {
    allTableDataWithExtraInfo,
    updateTableData,
    tableHasDataFromFirstLayer,
  } = useTableDataContext();
  const tableBodyRef = React.useRef(null);
  const [lineAdded, setLineAdded] = React.useState(false);

  const scrollToBottom = () => {
    if (tableBodyRef.current) {
      tableBodyRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }
  };

  const addNewRowFirstLayer = useCallback(() => {
    const newState = { ...allTableDataWithExtraInfo };

    newState.items_attributes.push({
      id: null,
      item_num: `${allTableDataWithExtraInfo.items_attributes.length + 1}`,
      description: '',
      items_attributes: [],
      price: 0,
      quantity: '',
      unit: '',
      unit_price: 0,
    });

    updateTableData(newState);
    setLineAdded(true);
  }, [allTableDataWithExtraInfo, updateTableData]);

  const onDragEnd = useCallback(
    (result) => {
      if (!result.destination) {
        return;
      }

      if (result.type === 'FIRST_LAYER') {
        const reorderedItems = Reorder(
          allTableDataWithExtraInfo.items_attributes,
          result.source.index,
          result.destination.index
        ).map((item, index) => ({ ...item, item_num: `${index + 1}` }));

        updateTableData({
          ...allTableDataWithExtraInfo,
          items_attributes: reorderedItems,
        });
        return;
      }

      // Second Layer
      if (result.type.split('-').length === 1) {
        const secondaryItems = Reorder(
          allTableDataWithExtraInfo.items_attributes[result.type]
            .items_attributes,
          result.source.index,
          result.destination.index
        ).map((item, index) => ({ ...item, item_num: `${index + 1}` }));

        const reorderedItems = [...allTableDataWithExtraInfo.items_attributes];

        reorderedItems[result.type].items_attributes = secondaryItems;

        updateTableData({
          ...allTableDataWithExtraInfo,
          items_attributes: reorderedItems,
        });
        return;
      }

      // Third Layer
      const layer = result.type.split('-');
      const tertiaryItems = Reorder(
        allTableDataWithExtraInfo.items_attributes[layer[0]].items_attributes[
          layer[1]
        ].items_attributes,
        result.source.index,
        result.destination.index
      ).map((item, index) => ({ ...item, item_num: `${index + 1}` }));

      const reorderedItems = [...allTableDataWithExtraInfo.items_attributes];

      reorderedItems[layer[0]].items_attributes[layer[1]].items_attributes =
        tertiaryItems;

      updateTableData({
        ...allTableDataWithExtraInfo,
        items_attributes: reorderedItems,
      });
    },
    [allTableDataWithExtraInfo, updateTableData]
  );

  React.useEffect(() => {
    if (lineAdded) {
      scrollToBottom();
      setLineAdded(false);
    }
  }, [lineAdded]);

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      <div>
        <TableContainer sx={{ marginBottom: 2 }} component={Paper}>
          <Table>
            <TableHeadStyled>
              <TableRow>
                <CellHeaderStyled sx={{ width: '2%' }} />
                {tableHasDataFromFirstLayer ? (
                  columns.map((column) => (
                    <CellHeaderStyled
                      key={uuid()}
                      align={column.align}
                      sx={{
                        width: column.width,
                      }}
                    >
                      {column.label}
                    </CellHeaderStyled>
                  ))
                ) : (
                  <TableCell style={{ textAlign: 'center', color: 'white' }}>
                    Nenhum Dado Encontrado
                  </TableCell>
                )}
              </TableRow>
            </TableHeadStyled>

            <DragDropContext onDragEnd={onDragEnd}>
              <Droppable droppableId="droppable" type="FIRST_LAYER">
                {(provided, snapshot) => (
                  <TableBodyStyled
                    ref={(el) => {
                      provided.innerRef(el);
                      tableBodyRef.current = el;
                    }}
                    style={getItemListStyle(snapshot.isDraggingOver)}
                  >
                    {allTableDataWithExtraInfo.items_attributes &&
                      allTableDataWithExtraInfo.items_attributes.map(
                        (firstLayerData, index) => (
                          <FirstLayerRow
                            key={firstLayerData.item_num}
                            itemNum={firstLayerData.item_num}
                            description={firstLayerData.description}
                            unit={firstLayerData.unit}
                            quantity={firstLayerData.quantity}
                            unitPrice={firstLayerData.unit_price}
                            price={firstLayerData.price}
                            isFinished={firstLayerData.is_finalized}
                            firstLayerIndex={index}
                          />
                        )
                      )}
                    {provided.placeholder}
                  </TableBodyStyled>
                )}
              </Droppable>
            </DragDropContext>
          </Table>
        </TableContainer>
        <Button
          fullWidth
          sx={{
            backgroundColor: (theme) => theme.palette.primary.main,
            color: (theme) => theme.palette.primary.contrastText,
            textTransform: 'none',
          }}
          onClick={addNewRowFirstLayer}
          startIcon={<AddIcon />}
        >
          Adicionar linha
        </Button>
      </div>
    </>
  );
};
